import { applyOperation } from './applyOperation.js';
export function applyOperations(target, ops) {
    for (const { table, muts } of ops) {
        for (const mut of muts) {
            applyOperation(target, table, mut);
        }
    }
}
